import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreEffects } from '@pit/core-store';
import { IDtoResource } from '@pit/frontend-model';
import { Observable } from 'rxjs';
import { DtoResourceStoreFactory } from './dto.resource.store.factory';

@Injectable()
export class DtoResourceEffects extends EntityStoreEffects<IDtoResource> {

    constructor(actions$: Actions, dataServiceAccessor: EntityDataServiceAccessorService) {
        super('dto.resource', actions$, DtoResourceStoreFactory.instance, dataServiceAccessor);
    }

    loadResourcesForMandatorByDepot$: Observable<Action> = DtoResourceStoreFactory.instance.getEffect('get.by.depot')(this.actions$, this.dataServiceAccessor);

}
